import { generateUniqueId, stripTimestampAndExtension } from '@/assets/js/Utilities';
import AIAutoCorrect from "@/assets/js/blocks/AIAutoCorrect";

export default class AIColourMatch extends AIAutoCorrect {
	constructor() {
		super();

		this.blockName = 'ai-colour-match';
		this.version = "1.0.0";

		this.curveNames = ["WhiteBalance-R", "WhiteBalance-G", "WhiteBalance-B", "Tint-R", "Tint-G", "Tint-B"];

		this.whiteBalance = {
			minValue: -4000,
			maxValue: 4000,
			calcValue: 8000,
		};

		this.tint = {
			minValue: -100,
			maxValue: 100,
			calcValue: 100,
		};

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	async addBlock(blockNum = lutify.blocks.length, selectedSampleFile = false) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);
		this.addExclamationMark($(element));
		UI.removeBlockBlendingModes($(element));
		UI.appendBlockLoadingSpinner($(element))

		await this.loadModel();
		$(element).find(".expand_options").trigger("click", [false]);

		$(element)
			.find('[data-control="favor-neutrality"]')
			.on("change", async e => {
				$(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');

				lutify.getActiveBlock().favourNeutrality = e.target.checked;
				lutify.getActiveBlock().favourContext = !e.target.checked;
				$(element).find('[data-control="favor-neutrality"]').prop('checked', e.target.checked);
				$(element).find('[data-control="favor-context"]').prop('checked', !e.target.checked);

				if (!lutify.getActiveBlock().sampleFile) return;
				let asset = await vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
				let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
				await this.predictAll(storeData.imageIDTLMT);
				this.showPreviews();
				this.resetOpacity();
			})

		$(element)
			.find('[data-control="favor-context"]')
			.on("change", async e => {
				$(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');

				lutify.getActiveBlock().favourContext = e.target.checked;
				lutify.getActiveBlock().favourNeutrality = !e.target.checked;
				$(element).find('[data-control="favor-context"]').prop('checked', e.target.checked);
				$(element).find('[data-control="favor-neutrality"]').prop('checked', !e.target.checked);

				if (!lutify.getActiveBlock().sampleFile) return;
				let asset = await vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
				let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
				await this.predictAll(storeData.imageIDTLMT);
				this.showPreviews();
				this.resetOpacity();
			})

		$(element)
			.find('[data-control="direct-transfer"]')
			.on("change", async e => {
				$(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');

				lutify.getActiveBlock().directTransfer = e.target.checked;

				if (!lutify.getActiveBlock().sampleFile) return;
				let asset = await vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
				let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
				await this.predictAll(storeData.imageIDTLMT);
				this.showPreviews();
				this.resetOpacity();
			})

		$(element)
			.find(".white_balance_slider")
			.on("input", () => _Adjustments.whiteBalance.whiteBalanceHandler($(element)));
		$(element)
			.find(".white_balance_range")
			.on("change", () => _Adjustments.whiteBalance.whiteBalanceValueHandler($(element)));

		$(element)
			.find(".tint_slider")
			.on("input", _ => _Adjustments.whiteBalance.tintHandler($(element)));
		$(element)
			.find(".tint_range")
			.on("change", _ => _Adjustments.whiteBalance.tintValueHandler($(element)));

		$(element)
			.find(".lut-selector__label-container")
			.on("click", e => {
				e.stopPropagation();
				if ($(e.currentTarget).hasClass('disabled')) return;
				this.togglePresetSelector($(e.currentTarget));
			});

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		$(element)
			.find(".btn-reset-block")
			.on("click", e => {
				e.stopPropagation();
				this.resetBlock($(element));
			});

		$(element).on("click", e => {
			e.stopImmediatePropagation();
			// UI.hideLUTtemplates();
			if (!lutify.getActiveBlock().sampleFile) return;
			if (!luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`]) return;
			if (luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`].length == 0) return;
			this.showPreviews();
		});

		$(element).find('.sample-selector').on('click', e => {
			vm.$root.projectTree.openAIColourMatchModal(vm.$store.state.Projects.currentFile, 'updateAIColourMatchSample');
		});

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "AIColourMatch",
			passes: this.addPasses(),
			version: this.version,
			curves: [],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			presetId: null,
			sampleFile: null,
			opacity: 100,
			favourContext: true,
			favourNeutrality: false,
			directTransfer: false,

			values: {
				whiteBalance: 0,
				tint: 0,
			}
		});

		$(element).find(".lut-selector__items-container").hide();

		blocks.createCurves(this.curveNames, blockNum);

		UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));

		if (!vm.$store.state.UI.showAddMatchTooltip && vm.$store.getters['Projects/allMatches'].length == 0) {
			vm.$store.dispatch('UI/setAddMatchTooltip', "Please load a reference image first, then save it as a Match using the option above to start using the AI Colour Match tool");
		}
	}

	async loadModel() {
		await super.loadModel('AI Colour Match');
	}

	async loadLuts() {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		UI.appendBlockLoadingSpinner($(UI.getActiveBlock()));

		UI.togglePreviewsContainer();
		lutPreviewer.showPlaceholderPreviews()

		let data = {
			control: 'LUTcontrols',
			category: 'White Balance'
		}

		await _Adjustments.LUTcontrols.load(data);

		if (typeof luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`] == "undefined") luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`] = [];
		let lutObjectsList = []

		let lutObjectClone = { ...lutify.getActiveBlock().lutObjects[0] };
		lutObjectClone.category = `AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`;
		lutObjectClone.presetId = 0;
		lutObjectClone.title = 'The Magic Look';
		luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`].push(lutObjectClone);
		lutPreviewer.createPreviews([lutObjectClone], false, undefined, 'AIColourMatch');
		lutObjectsList.push(lutObjectClone);

		for await (const [key, lutObject] of luts[data.control][data.category].entries()) {
			let lutObjectClone = { ...lutObject };
			lutObjectClone.category = `AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`;
			lutObjectClone.presetId = key + 1;
			let titleSplitted = lutObjectClone.title.split(/(\-|\+)/g);
			lutObjectClone.title = `The Magic Look ${titleSplitted[1]} WB ${titleSplitted[2]}`;

			luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`].push(lutObjectClone);
			lutPreviewer.createPreviews([lutObjectClone], false, undefined, 'AIColourMatch');
			lutObjectsList.push(lutObjectClone);
		}

		this.setPresetList(lutObjectsList);

		vm.$store.dispatch("Loader/showProgressBar", false);
		UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));
		lutPreviewer.removePlaceholderPreviews();
		UI.getActiveBlock().click();
	}

	addPasses() {
		let shaderPass_wb = gpu.createCurveShaderPass("white balance");
		let shaderPass_tint = gpu.createCurveShaderPass("tint");
		let passWhiteBalanceLut = gpu.createRenderPass();
		let passAIAutoCorrectForward = gpu.createRenderPass();
		let passAIAutoCorrectReverse = gpu.createRenderPass();

		gpu.addPassToComposer(shaderPass_wb, "toMiddle");
		gpu.addPassToComposer(shaderPass_tint, "toMiddle");
		gpu.addPassToComposer(passWhiteBalanceLut, "toMiddle");
		gpu.addPassToComposer(passAIAutoCorrectForward, "toMiddle");
		gpu.addPassToComposer(passAIAutoCorrectReverse, "toMiddle");

		return [shaderPass_wb, shaderPass_tint, passWhiteBalanceLut, passAIAutoCorrectForward, passAIAutoCorrectReverse];
	}

	togglePresetSelector($el) {
		let itemsContainer = $el.siblings(".lut-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	onPresetSelection(el, preset) {
		let category = 'AIColourMatch-' + lutify.getActiveBlock().passes[2].uid;
		$(`#previews-list-container .list-item[data-category="${category}"][data-preset-id="${preset.presetId}"]`).trigger('click');
		this.updatePresetList(preset);
	}

	updatePresetList(preset = false) {
		let $lutSelector = $(UI.getActiveBlock()).find(".lut-selector");
		$lutSelector.find(".lut-selector__items-container").hide();
		$lutSelector
			.find(`.lut-selector__items-container .--selected`)
			.removeClass("--selected");

		if (lutify.getActiveBlock().presetId !== null && preset) {
			$lutSelector.find(".selected-lut-name").html('Look: ' + preset.title);
			$lutSelector
				.find(`.lut-selector__items-container span[data-preset-id="${preset.presetId}"]`).addClass("--selected");
		} else {
			$lutSelector.find(".selected-lut-name").html('Select Look...');
		}
	}

	setPresetList(presets) {
		let $block = UI.getActiveBlock();

		presets.forEach(preset => {
			let el = document.createElement('span');
			el.innerHTML = preset.title;
			el.setAttribute('data-preset-id', preset.presetId);
			el.addEventListener('click', e => {
				this.onPresetSelection(e.currentTarget, preset);
			});

			$block.find('.lut-selector__items-container').append(el)
		});
	}

	async setSampleFile(file, lastState = false) {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		$(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');

		blocks.checkSwitchHandler($(UI.getActiveBlock()));

		let activeBlock = lutify.getActiveBlock();
		activeBlock.passes[2].uid = generateUniqueId();
		activeBlock.sampleFile = {
			id: file.id,
			type: file.type,
		};

		let asset = await vm.$store.getters["Projects/assetById"](file.id, file.type);
		let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);

		await this.predictAll(storeData.imageIDTLMT);
		await this.loadLuts();
		this.resetOpacity();

		if (!lastState) $(`#previews-list-container [data-category="AIColourMatch-${activeBlock.passes[2].uid}"][data-preset-id="0"] .scene`).trigger('click');

		$(UI.getActiveBlock()).find('.lut-selector__label-container').removeClass('disabled');
		this.setSampleFileUI(storeData.blob, asset.name);
		vm.$store.dispatch("Loader/showProgressBar", false);
	}

	setSampleFileUI(imageBlob, name) {
		if (!lutify.getActiveBlock()) return;
		let block = UI.getActiveBlock();
		let $block = $(block);

		let imgSrc = URL.createObjectURL(imageBlob);
		let imgElement = document.createElement('img');
		imgElement.setAttribute('src', imgSrc);
		imgElement.setAttribute('class', 'thumbnail');
		imgElement.setAttribute('data-tippy-content', 'Click to change a Match');
		$block.find('.sample-selector img').remove();
		$block.find('.sample-selector .select-asset-btn').addClass('hide');
		$block.find('.sample-selector').prepend(imgElement);

		name = stripTimestampAndExtension(name);
		$block.find('.sample-selector .name').text(`Selected Match: ${name}`);
	}

	resetSampleFileUI() {
		if (!lutify.getActiveBlock()) return;
		let $block = UI.getActiveBlock();

		$block.find('.sample-selector img').remove();
		$block.find('.sample-selector .select-asset-btn').removeClass('hide');
		$block.find('.sample-selector .name').text(``);
	}

	async predictAll(sourceBlob) {
		let AIAutoCorrectForwardLUT = await this.predict();
		this.applyForwardPass(AIAutoCorrectForwardLUT);

		let imageURL = URL.createObjectURL(sourceBlob);
		let AIAutoCorrectReverseLUT = await this.predict(imageURL, false);
		this.applyReversePass(AIAutoCorrectReverseLUT);
		URL.revokeObjectURL(imageURL);

		lutify.getActiveBlock().lutObjects = [AIAutoCorrectForwardLUT, AIAutoCorrectReverseLUT];
	}

	applyForwardPass(LUT) {
		let pass = gpu.createLUTPass(LUT.texture);
		pass.uid = lutify.getActiveBlock().passes[3].uid;
		pass.name = "AI Auto Correct - Forward";
		pass.enabled = lutify.getActiveBlock().directTransfer ? false : true;
		let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[3].uid);
		gpu.composer.passes[index] = pass;
		lutify.getActiveBlock().passes[3] = pass;
		gpu.render();
	}

	applyReversePass(LUT) {
		let pass = gpu.createLUTPass(LUT.texture);
		pass.uid = lutify.getActiveBlock().passes[4].uid;
		pass.name = "AI Auto Correct - Reverse";
		let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[4].uid);
		gpu.composer.passes[index] = pass;
		lutify.getActiveBlock().passes[4] = pass;
		gpu.render();
	}

	resetBlock($element) {
		this.resetOpacity();

		$element.find(".white_balance_range").val(0);
		$element.find(".white_balance_range").trigger('change');

		$element.find(".tint_range").val(0);
		$element.find(".tint_range").trigger('change');

		UI.hideLUTtemplates();
		lutify.getActiveBlock().sampleFile = null;
		lutify.getActiveBlock().presetId = null;
		this.resetSampleFileUI();

		if (lutify.getActiveBlock().favourNeutrality) {
			$element.find('[data-control="favor-context"]').trigger('click');
		}

		if (lutify.getActiveBlock().directTransfer) {
			$element.find('[data-control="direct-transfer"').trigger('click');
		}

		this.updatePresetList();
		$(UI.getActiveBlock()).find('.lut-selector__label-container').addClass('disabled');

		lutify.getActiveBlock().passes.forEach(pass => pass.enabled = false);
		gpu.render();
	}

	resetOpacity() {
		$(UI.getActiveBlock()).find(".opacity-input").val(100);
		$(UI.getActiveBlock()).find(".opacity-input").trigger("change");
	}

	showPreviews() {
		lutify.selectedPreviewCategory = `AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`;

		UI.togglePreviewsContainer();
		UI.updatePreviewsTab('AI Colour Match');
		lutPreviewer.switchCanvases(`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`);
		// UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview);

		lutPreviewer.cloneMainComposerPasses();
		lutPreviewer.addPass('LUTcontrols', `AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`, 2, lutify.getActiveBlock().blendingMode, 'AIColourMatch');

		if (lutify.getActiveBlock().presetId) {
			let preset = luts['LUTcontrols'][`AIColourMatch-${lutify.getActiveBlock().passes[2].uid}`].find(preset => preset.presetId == lutify.getActiveBlock().presetId)
			UI.updateSelectedPreview(preset.composerIndex);
		}

		lutPreviewer.render();
		setTimeout(() => lutPreviewer.render(), 50); // because of visual glitch
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes[2].uniforms.opacity.value = calcOpacityValue;
		lutify.getActiveBlock().passes[3].uniforms.opacity.value = calcOpacityValue;
		lutify.getActiveBlock().passes[4].uniforms.opacity.value = calcOpacityValue;

		if (lutify.getActiveBlock().sampleFile) {
			lutPreviewer.updateOpacity(calcOpacityValue, 2);
			lutPreviewer.updateOpacity(calcOpacityValue, 3);
			lutPreviewer.updateOpacity(calcOpacityValue, 4);
		}

		gpu.render();
		lutPreviewer.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	addExclamationMark($element) {
		let icon = document.createElement('i');
		icon.setAttribute('class', 'btn-block-needs-update material-icons hide');
		icon.setAttribute('data-tippy-content', 'You have changed the position or a value of AI Auto Correct. This might affect the result. Click this icon to re-calculate the result.');
		icon.innerHTML = 'error_outline';
		icon.addEventListener('click', async () => {
			$(UI.getActiveBlock()).find('.btn-block-needs-update').addClass('hide');

			if (!lutify.getActiveBlock().sampleFile) return;
			let asset = await vm.$store.getters["Projects/assetById"](lutify.getActiveBlock().sampleFile.id, lutify.getActiveBlock().sampleFile.type);
			let storeData = asset.type == 'media' ? await lutify.fetchImage(asset) : await lutify.fetchMatch(asset);
			await this.predictAll(storeData.imageIDTLMT);
			this.showPreviews();
			this.resetOpacity();
		});
		$element.find('.header-container .controls-wrapper').prepend(icon);
	}

	async applyChanges($block, values, blockData) {
		let activeBlockData = lutify.getActiveBlock();
		vm.$store.dispatch('App/setBlockLoading', true);
		$('#blocks-container--outer').addClass('--overlay');
		$('#project-navigator-container').addClass('--overlay');
		$('#filmstrip-container .thumbnail-container').addClass('--overlay');

		try {
			_Adjustments.whiteBalance.applyChanges($block, values, blockData);
			activeBlockData.presetId = blockData.presetId;

			if (!blockData.sampleFile) return;

			if (!await vm.$store.getters["Projects/assetById"](blockData.sampleFile.id, blockData.sampleFile.type)) {
				vm.$snackbar('Selected Match for AI Colour Match is no longer available. Please select a new one or otherwise remove the AI Colour Match tool.', 'error', {
					timeout: -1,
					contentClass: 'text-center'
				});
				return;
			}

			lutify.getActiveBlock().favourContext = blockData.favourContext;
			lutify.getActiveBlock().favourNeutrality = blockData.favourNeutrality;
			lutify.getActiveBlock().directTransfer = blockData.directTransfer;
			$block.find('[data-control="favor-context"]').prop('checked', blockData.favourContext);
			$block.find('[data-control="favor-neutrality"]').prop('checked', blockData.favourNeutrality);
			$block.find('[data-control="direct-transfer"]').prop('checked', blockData.directTransfer);

			if (blockData.directTransfer) {
				$block.find('[data-control="favor-neutrality"]').parent().addClass('--disabled pointer-events-none')
				$block.find('[data-control="favor-context"]').parent().addClass('--disabled pointer-events-none')
			}

			await this.setSampleFile(blockData.sampleFile, true);

			if (blockData.presetId !== null) {
				let preset = luts['LUTcontrols'][`AIColourMatch-${activeBlockData.passes[2].uid}`].find(preset => preset.presetId == activeBlockData.presetId);
				let pass = gpu.createLUTPass(preset.texture);
				pass.name = "lut-" + blockData.presetId;
				pass.uid = activeBlockData.passes[2].uid;
				pass.uniforms.opacity.value = activeBlockData.opacity * 0.01;
				if (blockData.presetId == '0') pass.enabled = false;

				activeBlockData.passes[2] = pass;
				let passIndex = gpu.getPassIndexById(pass.uid);
				gpu.composer.passes[passIndex] = activeBlockData.passes[2];

				$block.find(".opacity-input").val(parseInt(blockData.opacity));
				$block.find(".opacity-input").trigger("change");

				gpu.render();
				lutPreviewer.render();

				window.lutify.getActiveBlock().collapsedPreviews = blockData.collapsedPreviews;

				this.updatePresetList(preset);
			}

			$block.find(".controls-wrapper .switch > input").trigger("click");
		} finally {
			vm.$store.dispatch('App/setBlockLoading', false);
			$('#blocks-container--outer').removeClass('--overlay');
			$('#project-navigator-container').removeClass('--overlay');
			$('#filmstrip-container .thumbnail-container').removeClass('--overlay');
			vm.$store.dispatch("Loader/showProgressBar", false);
		}
	}
}
